export default class Event {
    public type: string;

    constructor(type: string) {
        this.type = type;
    }
}
